"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = void 0;
exports.COLORS = {
    red: {
        lightColor: '#D32157',
        darkColor: '#AF0A3C',
    },
    blue: {
        lightColor: '#05D1C6',
        darkColor: '#00B4AA',
    },
    orange: {
        lightColor: '#F99A79',
        darkColor: '#EC835F',
    },
    pink: {
        lightColor: '#EE7BA8',
        darkColor: '#DC6996',
    },
    default: {
        lightColor: '#7A7A7A',
        darkColor: '#5D5D5D',
    },
};
